<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row contactform" style="top: 70px">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
      <div class="col-md-6">
        <div
          class="fb-customerchat"
          page_id="264510810322608"
          theme_color="#2879FF"
        ></div>
        <div id="fb-root"></div>
      </div>
      <div class="col-md-6">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="left: 4px">
            <form
              [formGroup]="loginForm"
              (ngSubmit)="onSubmit()"
              class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10"
              style="
                top: -10px;
                left: -500px;
                width: 420px;
                height: 506px;
                background: white;
                border-radius: 4px;
                opacity: 1;
              "
            >
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div
                  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                  style="text-align: center; padding-bottom: 80px"
                >
                  <img
                    src="../../../assets/3plfs.png"
                    alt=""
                    style="height: 200px; width: 200px; margin-top: -29px"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row" style="top: -110px">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <label
                        for="username"
                        style="
                          letter-spacing: 0px;
                          color: black;
                          opacity: 1;
                          text-align: left;
                        "
                        >Username</label
                      >
                      <input
                        type="text"
                        formControlName="username"
                        class="form-control"
                        style="
                          box-shadow: 0px 3px 6px #00000029;
                          border-radius: 4px;
                          opacity: 1;
                        "
                        [ngClass]="{
                          'is-invalid': submitted && f.username.errors
                        }"
                      />
                      <div
                        *ngIf="submitted && f.username.errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="f.username.errors.required">
                          Username is required
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <label
                        for="password"
                        style="
                          text-align: left;
                          letter-spacing: 0px;
                          color: black;
  
                          opacity: 1;
                        "
                        >Password</label
                      >
                      <input
                        type="password"
                        formControlName="password"
                        class="form-control"
                        style="
                          box-shadow: 0px 3px 6px #00000029;
                          border-radius: 4px;
                          opacity: 1;
                        "
                        [ngClass]="{
                          'is-invalid': submitted && f.password.errors
                        }"
                      />
                      <div
                        *ngIf="submitted && f.password.errors"
                        class="invalid-feedback"
                      >
                        <div *ngIf="f.password.errors.required">
                          Password is required
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <button
                        [disabled]="loading"
                        class="col-md-6"
                        mat-raised-button color="primary"
                        
                      >
                        Log in
                      </button>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                      <a
                        href="http://3plfreightsoftware.com"
                        target="_blank"
                        rel="3plfreightsoftware"
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
                        style="
                          letter-spacing: 0px;
                          color: black;
                          font-size: 14px;
                          top: 20px;
                          text-align: justify;
                          padding-left: 0px;
                          padding-right: 0px;
                        "
                      >
                        2021 © 3PLFreightSoftware.com all rights reserved.
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  